import { Controller } from "@hotwired/stimulus"

// Lazily fetches the heavy MapLibre bundle (map.js, ~1.6 MB) only when the map
// container is about to scroll into view. The map sits below the fold on
// regions#show, so this keeps it off the critical path of the initial page load.
//
// The bundle and its stylesheet are injected into <head> exactly once per
// document. map.js boots its own Stimulus Application, which then connects the
// `map` controller to this element (and to any future map elements swapped in
// by Turbo) — so later region pages reuse the already-loaded bundle.
//
//   <div data-controller="map-loader map"
//        data-map-loader-script-src-value="<%= asset_path('map.js') %>"
//        data-map-loader-stylesheet-href-value="<%= asset_path('maplibre-gl.css') %>"
//        data-map-markers-value="[...]"></div>
export default class extends Controller {
  static values = {
    scriptSrc: String,
    stylesheetHref: String,
    rootMargin: { type: String, default: "600px 0px" }
  }

  connect() {
    // Bundle already injected (e.g. a previous Turbo visit) — map.js's app will
    // connect the `map` controller to this element on its own.
    if (window.__teevineMapLoaded) return

    if (!("IntersectionObserver" in window)) {
      this.#load()
      return
    }

    this.observer = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting)) this.#load()
    }, { rootMargin: this.rootMarginValue })
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
    this.observer = null
  }

  #load() {
    this.observer?.disconnect()
    this.observer = null
    if (window.__teevineMapLoaded) return
    window.__teevineMapLoaded = true

    if (this.stylesheetHrefValue) {
      const link = document.createElement("link")
      link.rel = "stylesheet"
      link.href = this.stylesheetHrefValue
      document.head.appendChild(link)
    }

    const script = document.createElement("script")
    script.type = "module"
    script.src = this.scriptSrcValue
    document.head.appendChild(script)
  }
}
